import { render, staticRenderFns } from "./u-pagination-filled-circle.vue?vue&type=template&id=65ffcfa5&scoped=true"
import script from "./u-pagination-filled-circle.vue?vue&type=script&lang=js"
export * from "./u-pagination-filled-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffcfa5",
  null
  
)

export default component.exports